import type { Account } from '@/types';
import { api } from './api-client';

export const AccountDetailsService = {
  getAccountDetails: async (): Promise<Account> => {
    const { data } = await api.get<{ data: Account }>(`/account-details`);
    return data;
  },
};
